import { useEffect, useState } from "react";

let snapshotActual = null;
const listeners = new Set();

function emit() {
  for (const fn of listeners) {
    try {
      fn(snapshotActual);
    } catch {
      // ignore
    }
  }
}

export function publicarSnapshotAnotador(snapshot) {
  snapshotActual = snapshot ?? null;
  emit();
}

export function limpiarSnapshotAnotador() {
  snapshotActual = null;
  emit();
}

export function obtenerSnapshotAnotador() {
  return snapshotActual;
}

export function suscribirSnapshotAnotador(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useAnotadorSnapshot() {
  const [snap, setSnap] = useState(snapshotActual);
  useEffect(() => {
    setSnap(snapshotActual);
    const off = suscribirSnapshotAnotador((s) => setSnap(s));
    return () => {
      off();
    };
  }, []);
  return snap;
}
